module.exports = __webpack_public_path__ + "img/logo_sicepat.de6535a3.svg";